import {
  API_ERROR,
  SECTION,
  SECTION_LIST_SUCCESSFUL,
  SECTION_ADD,
  SECTION_ADD_SUCCESSFUL,
  SECTION_EDIT,
  SECTION_EDIT_SUCCESSFUL,
  SECTION_DELETE,
  SECTION_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
} from "./actionTypes";

const initialState = {
  error: "Sorry! No Data Found.",
  message: null,
  loading: false,
  sectionlist: [],
  model: false,
  error_msg: null,
  rowdata: {},
};

const Section = (state = initialState, action) => {
  switch (action.type) {
    case SECTION:
      state = {
        ...state,
        loading: true,
      };
      break;
    case SECTION_LIST_SUCCESSFUL:
      state = {
        ...state,
        sectionlist: action.payload.response.results,
        loading: false,
      };
      break;
    case SECTION_ADD:
      state = {
        ...state,
        loading: false,
      };
      break;
    case SECTION_ADD_SUCCESSFUL:
      state = {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {Id:0},
      };
      break;
    case SECTION_EDIT:
      state = {
        ...state,
        model: true,
        rowdata: action.payload,
      };
      break;
    case SECTION_EDIT_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        rowdata: {Id:0},
      };
      break;
    case SECTION_DELETE:
      state = {
        ...state,
        loading: false,
      };
      break;
    case SECTION_SETROWDATA:
      state = {
        ...state,
        rowdata: action.payload,
        // model: true,
      };
      break;
    case MODEL_OPEN:
      state = {
        ...state,
        model: true,
      };
      break;
    case MODEL_CLOSE:
      state = {
        ...state,
        model: false,
        rowdata: { id: 0 },
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        loading: false,
        error_msg: action.payload,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Section;
